"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREDEFINED_DAY_TAGS = exports.UrgencyLevel = exports.TreatmentType = exports.QuoteStatus = void 0;
var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["PENDING"] = "pending";
    QuoteStatus["DOCTOR_REVIEW"] = "doctor_review";
    QuoteStatus["QUOTED"] = "quoted";
    QuoteStatus["ACCEPTED"] = "accepted";
    QuoteStatus["REJECTED"] = "rejected";
    QuoteStatus["EXPIRED"] = "expired";
    QuoteStatus["DRAFT"] = "draft";
    QuoteStatus["SUBMITTED"] = "submitted";
    QuoteStatus["SENT"] = "sent";
})(QuoteStatus || (exports.QuoteStatus = QuoteStatus = {}));
var TreatmentType;
(function (TreatmentType) {
    TreatmentType["DENTAL_IMPLANTS"] = "dental_implants";
    TreatmentType["VENEERS"] = "veneers";
    TreatmentType["CROWNS"] = "crowns";
    TreatmentType["BRIDGES"] = "bridges";
    TreatmentType["ROOT_CANAL"] = "root_canal";
    TreatmentType["ORTHODONTICS"] = "orthodontics";
    TreatmentType["TEETH_WHITENING"] = "teeth_whitening";
    TreatmentType["PERIODONTAL_TREATMENT"] = "periodontal_treatment";
    TreatmentType["ORAL_SURGERY"] = "oral_surgery";
    TreatmentType["FULL_MOUTH_RESTORATION"] = "full_mouth_restoration";
})(TreatmentType || (exports.TreatmentType = TreatmentType = {}));
var UrgencyLevel;
(function (UrgencyLevel) {
    UrgencyLevel["LOW"] = "low";
    UrgencyLevel["MEDIUM"] = "medium";
    UrgencyLevel["HIGH"] = "high";
    UrgencyLevel["EMERGENCY"] = "emergency";
})(UrgencyLevel || (exports.UrgencyLevel = UrgencyLevel = {}));
exports.PREDEFINED_DAY_TAGS = [
    'no_movement',
    'no_heavy_carrying',
    'soft_food_only',
    'rest_required',
    'no_sunlight',
    'light_activity_only',
];
//# sourceMappingURL=quote.types.js.map